import { FC } from 'react';
import { IconPath, IconSVG, IconSVGComponentProps } from '../IconComponent';

// This is an especially custom icon: size is 40x24. Be careful with
// how / where this is used to ensure it renders as expected.
export const JointPlentyAccount: FC<IconSVGComponentProps> = ({
    pathProps,
    ...props
}) => {
    return (
        <IconSVG viewBox="0 0 40 24" {...props}>
            <rect
                x="2.75"
                y="0.75"
                width="35.5"
                height="22.5"
                rx="11.25"
                stroke="currentColor"
                strokeWidth="1.5"
            />
            <IconPath
                d="M22.5 16s1.291-.988 3.259-.988c1.967 0 3.753.857 5.07 2.253m-2.535-7.04a2.535 2.535 0 1 1-5.07 0 2.535 2.535 0 0 1 5.07 0ZM10.69 17.265c1.315-1.396 3.101-2.253 5.069-2.253 1.967 0 3.753.857 5.07 2.253m-2.535-7.04a2.535 2.535 0 1 1-5.07 0 2.535 2.535 0 0 1 5.07 0Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                {...pathProps}
            />
        </IconSVG>
    );
};
